// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"521":"b5ccf153","561":"83ec2dde","691":"9b93e75a","725":"cf6faf22","878":"307564b9","960":"8af1092a","978":"39187cbd"}[chunkId] + ".chunk.js";
};